import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AvatarImage } from '@/components/workspace/avatar-image'

interface AvatarInfoProps {
  isCollapsed: boolean
  name?: string
  imgSrc?: string
  description?: string
}

const AvatarInfo: FunctionComponent<AvatarInfoProps> = ({
  isCollapsed,
  name = '',
  imgSrc,
  description,
}) => {
  return (
    <Wrapper>
      <AvatarWrapper>
        <AvatarImage imgSrc={imgSrc} name={name} />
      </AvatarWrapper>
      {!isCollapsed && (
        <TextWrapper>
          <Name>{name}</Name>
          <Description>{description}</Description>
        </TextWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  cursor: pointer;
  padding: 16px;
  justify-content: center;
  align-items: center;
`

const AvatarWrapper = styled.div`
  width: 40px;
  height: 40px;
`

const TextWrapper = styled.div`
  margin: 0 0 0 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  > div {
    width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

const Name = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  color: ${(props): string => props.theme.colors.base.grey.grey1};
`

const Description = styled.div`
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }): string => theme.colors.unclassified.grey.grey1};
`

export default AvatarInfo
